export default {
  common: {
    back: 'Volver',
    contact: 'Contacto',
    email: 'support@wedora.fr',
    privacyEmail: 'privacy@wedora.fr',
  },
  termsOfService: {
    title: 'Términos de Servicio',
    sections: {
      introduction: {
        title: '1. Introducción',
        content: 'Bienvenido a Wedora. Al usar nuestro servicio, aceptas cumplir con estos términos de servicio. Por favor, léelos cuidadosamente antes de usar nuestra plataforma.',
      },
      description: {
        title: '2. Descripción del Servicio',
        content: 'Wedora es una plataforma de planificación de bodas que permite a las parejas:',
        features: [
          'Gestionar su lista de invitados',
          'Seguir su presupuesto',
          'Organizar sus tareas',
          'Crear su sitio web de boda',
          'Comunicarse con sus proveedores',
        ],
      },
      accounts: {
        title: '3. Cuentas de Usuario',
        content: 'Para usar Wedora, debes crear una cuenta. Eres responsable de mantener la confidencialidad de tus credenciales y de todas las actividades que ocurran bajo tu cuenta.',
      },
      usage: {
        title: '4. Uso del Servicio',
        content: 'Al usar nuestro servicio, aceptas:',
        rules: [
          'No usar el servicio para fines ilegales',
          'No intentar comprometer la seguridad del servicio',
          'No compartir contenido inapropiado u ofensivo',
          'Respetar los derechos de otros usuarios',
        ],
      },
      intellectual: {
        title: '5. Propiedad Intelectual',
        content: 'Todo el contenido en Wedora, incluyendo pero no limitado a textos, gráficos, logotipos y código fuente, es propiedad de Wedora o sus socios y está protegido por las leyes de propiedad intelectual.',
      },
      modifications: {
        title: '6. Modificaciones de los Términos',
        content: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor una vez publicadas en el sitio. Tu uso continuado del servicio después de estas modificaciones constituye tu aceptación de los nuevos términos.',
      },
      contact: {
        title: '7. Contacto',
        content: 'Para cualquier pregunta sobre estos términos de servicio, por favor contáctanos en: support@wedora.fr',
      },
    },
  },
  privacyPolicy: {
    title: 'Política de Privacidad',
    sections: {
      introduction: {
        title: '1. Introducción',
        content: 'En Wedora, damos gran importancia a la protección de tus datos personales. Esta política de privacidad explica cómo recopilamos, usamos y protegemos tu información.',
      },
      dataCollection: {
        title: '2. Recopilación de Datos',
        content: 'Recopilamos la siguiente información:',
        types: [
          'Información de perfil (nombre, apellido, email)',
          'Información sobre tu boda (fecha, lugar)',
          'Lista de invitados',
          'Información de presupuesto',
          'Preferencias de personalización',
        ],
      },
      dataUsage: {
        title: '3. Uso de Datos',
        content: 'Usamos tus datos para:',
        purposes: [
          'Proporcionar y mejorar nuestros servicios',
          'Personalizar tu experiencia',
          'Comunicarnos contigo sobre tu cuenta',
          'Enviar notificaciones importantes',
          'Analizar y mejorar nuestros servicios',
        ],
      },
      dataProtection: {
        title: '4. Protección de Datos',
        content: 'Implementamos medidas de seguridad apropiadas para proteger tus datos contra cualquier acceso, modificación, divulgación o destrucción no autorizados. Tus datos se almacenan en servidores seguros y se cifran durante la transmisión.',
      },
      dataSharing: {
        title: '5. Compartir Datos',
        content: 'Nunca vendemos tus datos personales a terceros. Podemos compartir cierta información con nuestros proveedores de servicios que nos ayudan a operar nuestra plataforma, sujeto a estrictas obligaciones de confidencialidad.',
      },
      rights: {
        title: '6. Tus Derechos',
        content: 'De acuerdo con el GDPR, tienes los siguientes derechos:',
        list: [
          'Derecho de acceso a tus datos',
          'Derecho de rectificación',
          'Derecho al borrado',
          'Derecho a la portabilidad de datos',
          'Derecho a oponerte al procesamiento',
        ],
      },
      cookies: {
        title: '7. Cookies',
        content: 'Usamos cookies para mejorar tu experiencia en nuestra plataforma. Puedes controlar el uso de cookies a través de la configuración de tu navegador.',
      },
      contact: {
        title: '8. Contacto',
        content: 'Para cualquier pregunta sobre nuestra política de privacidad o para ejercer tus derechos, por favor contáctanos en: privacy@wedora.fr',
      },
    },
  },
}; 